<template>
  <div class="home">
    <h2>A/B Testing</h2>
    <b-button
      @click="raisePopup({ target: $event.target, isEdit: false })"
      variant="primary"
    >
      New Experiment
    </b-button>
    <b-button
      variant="danger"
      class="ml-3"
      @click="deleteUserPopup({ target: $event.target })"
      >Delete User by AppInstallId</b-button
    >
    <!-- Filtering -->
    <b-row class="ml-1 mt-3">
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="1" label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input
              v-model="filter.whitelabelId"
              placeholder="by Whitelabel ID"
              @keyup="forceFilter"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter.whitelabelId"
                @click="
                  filter = {};
                  forceFilter();
                "
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-modal
      id="deleteUserModal"
      title="Delete user by appIntallId"
      @ok="deleteUserSubmit"
      :ok-disabled="!deleteUserForm.appInstallId"
    >
      <b-form>
        <b-form-input
          id="deleteUserInput"
          type="text"
          v-model="deleteUserForm.appInstallId"
          placeholder="appInstallId"
        />
      </b-form>
    </b-modal>
    <b-modal
      id="abtestingModal"
      v-bind:title="this.isEdit ? 'Edit Experiment' : 'New Experiment'"
      @ok="abtestingFormSubmit"
      :ok-disabled="isFormValid"
    >
      <b-form>
        <!-- WhiteLabel ID -->
        <b-form-group
          id="abtestingInputGroup1"
          label="Whitelabel ID:"
          label-for="abtestingInput1"
        >
          <b-form-select
            v-model="form.whitelabelId"
            v-if="this.$store.state.whitelabels.rows"
            :options="[
              { value: null, text: 'Choose Whitelabel' },
              ...this.$store.state.whitelabels.rows.map(wl => ({
                value: wl.id,
                text: wl.name
              }))
            ]"
          ></b-form-select>
        </b-form-group>
        <!-- Platform ID -->
        <b-form-group
          id="abtestingInputGroup2"
          label="Platform ID:"
          label-for="abtestingInput2"
        >
          <div v-if="form.platformIds.length > 0">
            <b-row
              v-for="(platformId, index) in form.platformIds"
              :key="index"
              class="mb-1"
            >
              <b-col sm="8">
                <b-form-select
                  v-model="platformId.value"
                  @change="onSelectPlatformId()"
                  :options="getAllPlatformsArray()"
                ></b-form-select>
              </b-col>
              <b-col sm="4">
                <b-button
                  type="button"
                  @click="
                    removeFromFormArray('platformIds', index);
                    onSelectPlatformId();
                  "
                  variant="danger"
                >
                  Delete
                </b-button>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col sm="8"></b-col>
            <b-col sm="4">
              <b-button
                type="button"
                size="sm"
                @click="addFieldToFormArray('platformIds')"
                variant="outline-success"
              >
                Add Platform ID
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
        <!-- RecordsCount -->
        <b-form-group
          id="abtestingInputGroup3"
          label="Records Count:"
          label-for="abtestingInput3"
        >
          <b-form-input
            id="abtestingInput3"
            type="number"
            v-model="form.recordsCount"
            placeholder="Enter the count of records"
          />
        </b-form-group>

        <!-- Model Names -->
        <b-form-group
          id="abtestingInputGroup4"
          label="Model Names:"
          label-for="abtestingInput4"
        >
          <b-row
            v-for="(modelName, index) in form.modelNames"
            :key="index"
            class="mb-1"
          >
            <b-col sm="8">
              <b-form-input
                :id="`modelName-${index}`"
                type="text"
                v-model="modelName.value"
                placeholder="Enter Model Name"
              />
            </b-col>
            <b-col sm="4">
              <b-button
                type="button"
                @click="removeFromFormArray('modelNames', index)"
                variant="danger"
              >
                Delete
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="8"></b-col>
            <b-col sm="4">
              <b-button
                type="button"
                size="sm"
                @click="addFieldToFormArray('modelNames')"
                variant="outline-success"
              >
                Add Model
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>

        <!-- Is Experiment Active -->
        <b-form-checkbox
          v-model="form.isActive"
          :disabled="true"
          name="check-button"
          switch
        >
          Is Experiment Active
        </b-form-checkbox>
        <!-- Is Experiment Active -->
        <b-form-checkbox v-model="form.isCollecting" name="check-button" switch>
          Collecting Users
        </b-form-checkbox>
        <!-- Enable Random Save -->
        <b-row>
          <b-col sm="6">
            <b-form-checkbox
              v-model="form.isRandomSaveEnable"
              name="check-button"
              switch
            >
              isRandomSaveEnable
            </b-form-checkbox>
          </b-col>
          <b-col sm="6">
            <!-- Chance is isRandomSaveEnable -->
            <b-form-group
              id="abtestingInputProbability"
              label="Probability:"
              label-for="abtestingInputProbability"
            >
              <b-form-input
                id="abtestingInputProbability"
                type="number"
                v-model="form.probability"
                :disabled="!form.isRandomSaveEnable"
                max="1"
                min="0"
                placeholder="Chance (0 - 1)"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Deployment Settings -->
        <b-form-group
          class="mt-3"
          id="abtestingInputGroup5"
          label="Deployment Settings:"
          label-for="abtestingInput5"
        >
          <div
            v-for="(deploymentSettings,
            index) in form.versionsDeploymentSettings"
            :key="index"
            class="mb-1 "
          >
            <b-row class="mb-3">
              <b-col sm="8">
                <b-form-input
                  :id="`deploymentSettingsCount-${index}`"
                  type="number"
                  v-model="deploymentSettings.count"
                  placeholder="Count"
                />
              </b-col>
              <b-col sm="4">
                <b-button
                  type="button"
                  @click="
                    removeFromFormArray('versionsDeploymentSettings', index)
                  "
                  variant="danger"
                >
                  Delete Block
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-3"
              ><b-col sm="3">
                <label for="`deploymentSettingsPlatforms-group-name-${index}}`"
                  >Group name</label
                >
              </b-col>
              <b-col sm="9">
                <b-form-input
                  :id="`deploymentSettingsPlatforms-group-name-${index}}`"
                  type="text"
                  v-model="deploymentSettings.groupName"
                ></b-form-input></b-col
            ></b-row>
            <b-row
              v-for="(pls, platformIndex) in deploymentSettings.platforms"
              :key="platformIndex + '-' + index"
              class="mb-1 "
            >
              <b-col sm="3">
                <b-form-input
                  :disabled="true"
                  v-model="pls.platform"
                ></b-form-input>
              </b-col>
              <b-col sm="9">
                <b-form-input
                  :id="`deploymentSettingsPlatforms-${index}-${platformIndex}`"
                  type="text"
                  v-model="pls.value"
                  placeholder='["bundleA.js","styleA.css"]'
                />
              </b-col>
            </b-row>
            <hr />
          </div>
          <b-row>
            <b-col sm="8"></b-col>
            <b-col sm="4">
              <b-button
                type="button"
                size="sm"
                @click="addFieldToFormArray('versionsDeploymentSettings')"
                variant="outline-success"
              >
                Add Block
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-container fluid>
      <b-table
        show-empty
        small
        striped
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        stacked="md"
        ref="ABTestingTable"
        class="abtesting-table"
      >
        <template v-slot:cell(whitelabelId)="row">
          {{ row.item.whitelabelId }} ({{ row.item.whitelabel.name }})
        </template>
        <template v-slot:cell(platformIds)="row">
          {{ row.item.platformIds }}
        </template>
        <pre></pre>
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1 ml-3"
            variant="warning"
            @click="
              raisePopup({
                id: row.item.id,
                isEdit: true,
                whitelabelId: row.item.whitelabelId,
                isActive: row.item.isActive,
                isCollecting: row.item.isCollecting,
                isRandomSaveEnable: row.item.isRandomSaveEnable,
                platformIds: JSON.parse(row.item.platformIds).map(i => ({
                  value: i
                })),
                probability: +row.item.probability,
                recordsCount: row.item.recordsCount,
                versionsDeploymentSettings: JSON.parse(
                  row.item.versionsDeploymentSettings
                ).map(i => ({
                  platforms: Object.keys(i.customUrl).map(platform => ({
                    platform,
                    value: i.customUrl[platform]
                  })),
                  count: i.count,
                  groupName: i.groupName
                })),
                modelNames: JSON.parse(row.item.modelNames).map(i => ({
                  value: i
                })),
                target: $event.target
              })
            "
          >
            ✎
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="deleteAbTesting(row.item.id)"
          >
            X
          </b-button>
          <b-button
            size="sm"
            variant="light"
            class="m-1 ml-3"
            @click="showUsersForTesting(row.item.id)"
          >
            ℹ
          </b-button>
        </template>
        <template v-slot:cell(isActive)="row">
          <b-form-checkbox
            v-model="row.item.isActive"
            name="check-button"
            switch
            class="active-switch"
            size="lg"
            :disabled="row.item.isCollecting"
            @change="changeIsActive(row.item.id)"
          >
          </b-form-checkbox>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */

export default {
  name: 'ABTesting',
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      filter: {
        whitelabelId: ''
      },
      isEdit: false,
      form: {
        whitelabelId: null,
        platformIds: [{ value: '' }],
        recordsCount: null,
        modelNames: [{ value: '' }],
        isActive: false,
        isCollecting: true,
        isRandomSaveEnable: true,
        probability: 1,
        versionsDeploymentSettings: [{ count: '', platforms: [] }]
      },
      deleteUserForm: {
        appInstallId: null
      }
    };
  },
  computed: {
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true
        },
        {
          key: 'whitelabelId',
          label: 'Whitelabel',
          sortable: true
        },
        {
          key: 'modelNames',
          label: 'Models',
          sortable: false
        },
        {
          key: 'recordsCount',
          label: 'Records',
          sortable: true
        },
        {
          key: 'isRandomSaveEnable',
          label: 'Randomized',
          sortable: true
        },
        {
          key: 'probability',
          label: 'Probability',
          sortable: false
        },
        {
          key: 'platformIds',
          label: 'Platform Ids',
          sortable: false
        },
        {
          key: 'versionsDeploymentSettings',
          label: 'Settings',
          sortable: false
        },
        {
          key: 'isCollecting',
          label: 'Collecting Users',
          sortable: true
        },
        { key: 'actions', label: 'actions' },
        {
          key: 'isActive',
          label: 'Active',
          sortable: true
        }
      ];
    },
    totalRows() {
      return this.$store.state.abTesting.count;
    },
    isFormValid() {
      const totalSum = this.form.versionsDeploymentSettings.reduce(
        (acc, cur) => {
          const count = +cur.count || 0;
          acc += count;
          return acc;
        },
        0
      );
      return (
        !this.form.whitelabelId ||
        !this.form.platformIds[0].value ||
        !this.form.recordsCount ||
        this.form.recordsCount == 0 ||
        totalSum != +this.form.recordsCount ||
        +this.form.probability > 1 ||
        +this.form.probability < 0
      );
    }
  },

  methods: {
    deleteUserPopup({ target }) {
      this.$root.$emit('bv::show::modal', 'deleteUserModal', target);
    },
    raisePopup({
      id,
      whitelabelId,
      isActive,
      isCollecting,
      recordsCount,
      isRandomSaveEnable,
      platformIds,
      versionsDeploymentSettings,
      modelNames,
      probability,
      isEdit,
      target
    }) {
      this.$root.$emit('bv::show::modal', 'abtestingModal', target);
      this.isEdit = isEdit;
      this.form.whitelabelId = isEdit ? whitelabelId : null;
      this.form.platformIds = isEdit ? platformIds : [{ value: '' }];
      this.form.versionsDeploymentSettings = isEdit
        ? versionsDeploymentSettings
        : [{ count: '', platforms: [] }];
      this.form.modelNames = isEdit ? modelNames : [{ value: '' }];
      this.form.isActive = !!isActive;
      this.form.probability = isEdit ? +probability : 1;
      this.form.isCollecting = isEdit ? isCollecting : true;
      this.form.isRandomSaveEnable = !!isRandomSaveEnable;
      this.form.recordsCount = isEdit ? recordsCount : null;
      this.form.id = id || null;
    },

    deleteAbTesting(id) {
      if (confirm('Delete this item?')) {
        const promise = this.$store.dispatch('removeAbTesting', {
          id
        });
        promise.then(() => this.$refs.ABTestingTable.refresh());
      }
    },
    showUsersForTesting(id) {
      this.$router.push(`/abtesting/${id}`);
    },
    changeIsActive(id) {
      const promise = this.$store.dispatch('changeAbTestingIsActive', {
        id
      });
      promise
        .then(() => this.$refs.ABTestingTable.refresh())
        .catch(() => this.$refs.ABTestingTable.refresh());
    },
    abtestingFormSubmit() {
      const formData = new FormData();
      if (this.form.id) formData.append('id', this.form.id);
      formData.append('whitelabelId', this.form.whitelabelId);
      formData.append('isActive', this.form.isActive);
      formData.append('probability', this.form.probability);
      formData.append('isCollecting', this.form.isCollecting);
      formData.append('isRandomSaveEnable', this.form.isRandomSaveEnable);
      formData.append('recordsCount', +this.form.recordsCount);
      formData.append(
        'versionsDeploymentSettings',
        JSON.stringify(
          this.form.versionsDeploymentSettings.map(i => ({
            count: i.count,
            groupName: i.groupName,
            customUrl: i.platforms.reduce((acc, curr) => {
              return { ...acc, ...{ [curr.platform]: curr.value } };
            }, {})
          }))
        )
      );
      formData.append(
        'modelNames',
        JSON.stringify(this.form.modelNames.map(i => i.value.trim()))
      );
      formData.append(
        'platformIds',
        JSON.stringify(this.form.platformIds.map(i => i.value))
      );
      const promise = this.$store.dispatch(
        this.isEdit ? 'editAbTesting' : 'addAbTesting',
        formData
      );
      promise.then(() => this.$refs.ABTestingTable.refresh());
    },
    deleteUserSubmit() {
      const promise = this.$store.dispatch('removeUserFromAbTesting', {
        appInstallId: this.deleteUserForm.appInstallId
      });
      return promise
        .then(() => {
          this.deleteUserForm.appInstallId = null;
        })
        .catch(() => {
          this.deleteUserForm.appInstallId = null;
        });
    },
    forceFilter() {
      this.$refs.ABTestingTable.refresh();
    },

    items(ctx) {
      const currentFilter = Object.keys(this.filter).reduce(
        (acc, curr) =>
          this.filter[curr] ? { ...acc, [curr]: this.filter[curr] } : acc,
        {}
      );
      const promise = this.$store.dispatch('getAbTestings', {
        ctx,
        filter: currentFilter
      });

      return promise.then(() => {
        const items = this.$store.state.abTesting.rows;
        return items || [];
      });
    },
    getWhitelabels() {
      const promise = this.$store.dispatch('getWhitelabels', {
        sortDesc: false,
        perPage: 30,
        currentPage: 1
      });
      return promise.then(() => {});
    },
    getPlatforms() {
      const promise = this.$store.dispatch('getPlatforms', {
        sortDesc: false,
        perPage: 30,
        currentPage: 1
      });
      return promise.then(() => {});
    },
    getAllPlatformsArray() {
      if (this.$store.state.platforms.rows) {
        return this.$store.state.platforms.rows.map(p => ({
          value: p.id,
          text: p.name
        }));
      } else {
        return [];
      }
    },
    getSelectedPlatformsArray() {
      if (this.$store.state.platforms.rows) {
        return this.$store.state.platforms.rows
          .map(p => ({
            id: p.id,
            value: p.name,
            text: p.name
          }))
          .filter(obj => {
            const platformIndex = this.form.platformIds.findIndex(
              i => i.value === obj.id
            );
            return platformIndex !== -1;
          });
      } else {
        return [];
      }
    },
    onSelectPlatformId() {
      this.form.versionsDeploymentSettings = this.form.versionsDeploymentSettings.map(
        settings => {
          settings.platforms = this.getSelectedPlatformsArray().map(pls => ({
            platform: pls.value,
            value:
              settings.platforms.find(i => i.platform === pls.value)?.value ||
              ''
          }));
          return settings;
        }
      );
    },
    addFieldToFormArray(name) {
      const config = {
        versionsDeploymentSettings: [{ count: '', platforms: [] }],
        modelNames: [{ value: '' }],
        platformIds: [{ value: '' }]
      };
      this.form[name].push({ ...config[name][0] });
      this.onSelectPlatformId();
    },
    removeFromFormArray(name, index) {
      const config = {
        versionsDeploymentSettings: [
          { count: '', platforms: [{ platform: null, value: '' }] }
        ],
        modelNames: [{ value: '' }],
        platformIds: [{ value: '' }]
      };

      if (this.form[name].length === 1) {
        this.form[name] = [...config[name]];
      } else {
        this.form[name].splice(index, 1);
      }
    }
  },
  created: function() {
    this.getWhitelabels();
    this.getPlatforms();
  }
};
</script>

<style scoped>
.abtesting-table {
  margin-top: 2rem;
}

.edit-warning {
  display: inline-block;
  margin-bottom: 1rem;
  color: red;
}

.active-switch {
  display: inline-block;
  margin-left: 1rem;
}
</style>
